/** Pop-up de invitare, deschis din iconița de lângă spațiu (sidebar). */
import { useTranslation } from 'react-i18next';

import Modal from '@/components/Modal';
import InviteForm from '@/features/account/InviteForm';
import RoleLegend from '@/features/account/RoleLegend';

interface Props {
  tenantId: string;
  tenantName: string;
  onClose: () => void;
}

export default function InviteModal({ tenantId, tenantName, onClose }: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      open
      onClose={onClose}
      title={
        <h2 className="display-title-sm">{t('tenant_invites.modal_title', { name: tenantName })}</h2>
      }
    >
      <div className="space-y-4">
        <InviteForm tenantId={tenantId} />
        <div className="pt-4 border-t border-[var(--border)]">
          <RoleLegend />
        </div>
      </div>
    </Modal>
  );
}
